<div class="" [ngStyle]="(currentModule != 'personsearch') && {'border-radius': '8px' }" [ngClass]="{'wccard':calledFrom != 'mainscreen' || searchToolboxHistory?.length > 0, 'px-3 py-2': searchToolboxHistory?.length }" *ngIf="!openModal">
  <div class="d-flex justify-content-between" *ngIf="calledFrom != 'mainscreen'">
    <span class="f-12 font-weight-600"  *ngIf="!save && searchToolboxHistory?.length > 0 && calledForSaveSearch != 'saveSearch'">
      <i class="far fa-clock mr-1"></i>History
    </span>

    <span class="f-14 font-weight-600" *ngIf="save && searchToolboxHistory?.length > 0">
      <i class="far fa-save mr-1"></i>{{isTalentInsightsPage ? 'Saved Insights' : 'Saved Searches'}}
    </span>
     <span class="f-14 font-weight-600" *ngIf="calledForSaveSearch == 'saveSearch'">
      <i class="far fa-save mr-1"></i>{{isTalentInsightsPage ? 'Saved Insights' : 'Saved Searches'}}
    </span>

    <!-- <span class="text-webbtree-green pointer f-12 font-weight-500" (click)="openHistoryModal()"
      *ngIf="searchToolboxHistory?.length > 0">
      View All
    </span> -->
  </div>
  <hr class="mt-3 mb-0" style="border-top: 1px solid rgba(0, 0, 0, 0.1);" *ngIf="calledFrom != 'mainscreen' && searchToolboxHistory?.length > 0">





<!--
  <div class="wccard empty-loader" *ngIf="searchHistoryLoader">
    <img style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader">
  </div> -->

  <div *ngIf="searchToolboxHistory?.length == 0 && !searchHistoryLoader" class="wccard">
    <div class="emptyScreen d-flex align-items-center justify-content-center" [ngStyle]="{'height': save ? '300px' : null }">
      <div class="createFirstTalenpool">
        <div class="text-center">
          <div class="text-center mb-3">
            <img src="../../../assets/images/search-engine-1.png" style="width: 150px;" alt="" srcset="">
          </div>
          <p *ngIf="!save" class="f-12 font-weight-500 text-center mb-5">You haven't initiated a search yet.<br> Start the search to add it to your search history.</p>
          <p *ngIf="save" class="f-12 font-weight-500 text-center mb-5">You haven't saved a search yet.<br> Save the search to add it to your saved searches.</p>
        </div>
      </div>
    </div>
  </div>
</div>

  <div class="modal-content" *ngIf="openModal">
    <div class="modal-header hire-modal-header w-100">
      <div class="d-flex justify-content-between text-defualt w-100">
        <div>
          <span class="font-weight-600" *ngIf="!save">
             <i class="far fa-clock mr-1"></i> Search History
          </span>

          <span class="f-12 font-weight-600" *ngIf="save">
            <i class="far fa-save mr-1"></i>{{isTalentInsightsPage ? 'Saved Insights' : 'Saved Searches'}}
          </span>

        </div>

        <span class="f-14 font-weight-600 pointer">
          <span><i class="far fa-times f-14" (click)="modalService.dismissAll()"> </i></span>
        </span>
      </div>
    </div>

    <div class="modal-body px-3 pb-6 pt-3">
      <!-- <div class="d-flex justify-content-between mb-1 pb-2" style="border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
        <div>
          <span class="font-weight-600" *ngIf="!save">
             <i class="far fa-clock mr-1"></i> Search History
          </span>

          <span class="f-12 font-weight-600" *ngIf="save">
            <i class="far fa-save mr-1"></i>{{isTalentInsightsPage ? 'Saved Insights' : 'Saved Searches'}}
          </span>

        </div>
        <span class="text-bluex pointer">
          <i class="far fa-times f-16" (click)="modalService.dismissAll()"> </i>
        </span>
      </div> -->
      <div class="scroll-widget teste" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
        [scrollWindow]="false" (scrolled)="gethistory('pagination')">
        <div *ngIf="!searchHistoryLoader && searchToolboxHistory?.length > 0">
                  <div *ngFor="let history of searchToolboxHistory; index as i" class="row mx-0 mb-3px py-2 "
        style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin-right: 10px !important;">
        <div class="col bb-3px">
          <div class="row">
            <div class="col d-flex justify-content-between mb-0 px-0">
              <a data-testid="auto-app-search-history-a-1" class="gray-text pointer collapsed font-weight-normal d-flex justify-content-between w-100"
                data-bs-toggle="collapse" href="#collapseExample{{i}}" role="button" aria-expanded="false"
                aria-controls="collapseExample" [ngClass]="{'showdhidearrow':!history.booleanquery}">
                <div class="">

                  <div class="f-12 font-weight-500 text-black mb-1 text-truncate" style="width:550px" (click)="searchFromHistory(history)">
                    <span *ngIf="!save" class="line-clamp" [matTooltip]="history?.title" [matTooltipClass]="{ 'hire-tooltip text-black': true }" matTooltipPosition="above">{{history?.title}}</span>
                    <span class="" *ngIf="!save"></span>
                    <span *ngIf="save" class="line-clamp" [matTooltip]="history?.talentdiscoveryname" [matTooltipClass]="{ 'big-tooltip': true }" matTooltipPosition="above" class="text-truncate whitespace-pre mb-1">{{history?.talentdiscoveryname || '-'}}</span>

                  </div>
                  <div class="d-flex">
                      <span style="font-size: 12px; font-weight: 400;" class="text-9696">{{formatDate(history?.updatedon)}}</span>
                      <span style="font-size: 12px; font-weight: 400;" class="text-9696" *ngIf="history?.issharedsearch ">&nbsp;|&nbsp;<span>Shared by {{history?.sharedby}}</span></span>
                    </div>
                </div>

                <div class="d-inline-flex">
                  <span *ngIf="members?.length && !history?.issharedsearch && save" (click)="openSaveSearchShareModal(history)" class="mr-2" title="Share">
                    <i class="text-bluex pointer fa-regular fa-share-nodes"></i>
                  </span>

                  <span *ngIf="currentUserId == history?.savedby && save" (click)="editSavedSearch(history)" class="mr-2" title="Edit">
                    <i class="text-bluex pointer far fa-edit"></i>
                  </span>
                  <span *ngIf="currentUserId == history?.savedby && save" (click)="triggerDeleteSaveModal(history)" class="mr-2" title="Delete">
                    <i class="text-bluex pointer far fa-trash"></i>
                  </span>
                  <p style="color: #2e93a1;" (click)="searchFromHistory(history)"><i class="fa-regular fa-search"></i></p>
                </div>
                <div *ngIf="history.booleanquery">
                  <div class="col d-flex justify-content-between">
                    <p class="f-10 text-9696 mr-2 mt-1 mb-0">{{formatDate(history?.updatedon)}}</p>

                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
        </div>
        </div>
            <div *ngIf="searchToolboxHistory?.length == 0 && !searchHistoryLoader" class="wccard">
    <div class="emptyScreen d-flex align-items-center justify-content-center" [ngStyle]="{'height': save ? '300px' : null }">
      <div class="createFirstTalenpool">
        <div class="text-center">
          <div class="text-center mb-3">
            <img src="../../../assets/images/search-engine-1.png" style="width: 150px;" alt="" srcset="">
          </div>
          <p *ngIf="!save" class="f-12 font-weight-500 text-center mb-5">You haven't initiated a search yet.<br> Start the search to add it to your search history.</p>
          <p *ngIf="save" class="f-12 font-weight-500 text-center mb-5">You haven't saved a search yet.<br> Save the search to add it to your saved searches.</p>
        </div>
      </div>
    </div>
  </div>

         <div class="skeleton-page mb-2 px-0 pt-3" *ngIf="searchHistoryLoader">
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
            <div class="d-flex align-items-center w-100 mb-2 justify-content-between">
              <div style="width: calc(100% - 30px);">
                <div class="sk-box title-bar mb-1" style="width: 60%;height: 6px;"></div>
                <div class="sk-box chip-label mb-1" style="width: 30%;"></div>
              </div>
               <div class="mr-1" style="width: 26px;">
                <div class="checkbox sk-box" style="border-radius: 4PX;"></div>
              </div>
            </div>
          </div>

      </div>

    </div>
  </div>

<ng-template #historymodal class="modal">
  <div class="modal-content">
    <div class="modal-body px-3 pb-6 pt-3">
      <div class="d-flex justify-content-between mb-1 pb-2" style="border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
        <div>
          <span class="font-weight-600" *ngIf="!save">
             <i class="far fa-clock mr-1"></i> Search History
          </span>

          <span class="f-12 font-weight-600" *ngIf="save">
            <i class="far fa-save mr-1"></i>{{isTalentInsightsPage ? 'Saved Insights' : 'Saved Searches'}}
          </span>

        </div>
        <span class="text-bluex pointer">
          <i class="far fa-times f-16" (click)="modalService.dismissAll()"> </i>
        </span>
      </div>
      <div class="scroll-widget" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
        [scrollWindow]="false" (scrolled)="gethistory('pagination')">
        <div *ngFor="let history of searchToolboxHistory; index as i" class="row mx-0 mb-3px py-2 "
        style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin-right: 10px !important;">
        <div class="col bb-3px">
          <div class="row">
            <div class="col d-flex justify-content-between mb-0 px-0">
              <a data-testid="auto-app-search-history-a-2" class="gray-text pointer collapsed font-weight-normal d-flex justify-content-between w-100"
                data-bs-toggle="collapse" href="#collapseExample{{i}}" role="button" aria-expanded="false"
                aria-controls="collapseExample" [ngClass]="{'showdhidearrow':!history.booleanquery}">
                <div class="">

                  <div class="f-12 font-weight-500 text-black mb-1 text-truncate" style="width:550px" (click)="searchFromHistory(history)">
                    <span *ngIf="!save" class="line-clamp" [matTooltip]="history?.title" [matTooltipClass]="{ 'big-tooltip text-black': true }" matTooltipPosition="above">{{history?.title}}</span>
                    <span class="" *ngIf="!save"></span>
                    <span *ngIf="save" class="line-clamp" [matTooltip]="history?.talentdiscoveryname" [matTooltipClass]="{ 'big-tooltip': true }" matTooltipPosition="above" class="text-truncate whitespace-pre mb-1">{{history?.talentdiscoveryname || '-'}}</span>

                  </div>
                  <div class="d-flex">
                      <span style="font-size: 12px; font-weight: 400;" class="text-9696">{{formatDate(history?.updatedon)}}</span>
                      <span style="font-size: 12px; font-weight: 400;" class="text-9696" *ngIf="history?.issharedsearch ">&nbsp;|&nbsp;<span>Shared by {{history?.sharedby}}</span></span>
                    </div>
                </div>

                <div class="d-inline-flex">
                  <span *ngIf="members?.length && !history?.issharedsearch && save" (click)="openSaveSearchShareModal(history)" class="mr-2" title="Share">
                    <i class="text-bluex pointer fa-regular fa-share-nodes"></i>
                  </span>

                  <span *ngIf="currentUserId == history?.savedby && save" (click)="editSavedSearch(history)" class="mr-2" title="Edit">
                    <i class="text-bluex pointer far fa-edit"></i>
                  </span>
                  <span *ngIf="currentUserId == history?.savedby && save" (click)="triggerDeleteSaveModal(history)" class="mr-2" title="Delete">
                    <i class="text-bluex pointer far fa-trash"></i>
                  </span>
                  <p style="color: #2e93a1;" (click)="searchFromHistory(history)"><i class="fa-regular fa-search"></i></p>
                </div>
                <div *ngIf="history.booleanquery">
                  <div class="col d-flex justify-content-between">
                    <p class="f-10 text-9696 mr-2 mt-1 mb-0">{{formatDate(history?.updatedon)}}</p>

                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      </div>

    </div>
  </div>
</ng-template>

<div class="wccard" *ngIf="save && calledFrom == 'talent-insights'">
  <div class="project-list-container mb-3" >
  <div class="row mx-0 project-list-header">
    <div class="col-md-4 header-item">
      Saved Insights
    </div>
    <div class="col header-item">
      Created from
    </div>
    <div class="col header-item">
      Generated On
    </div>
    <div class="col header-item">
     Updated On
    </div>
    <div class="col header-item justify-content-between">
    <span></span>

    </div>

  </div>
  @for(search of searchToolboxHistory; track search){
  <div class="row mx-0 project-list">
    <div class="col-md-4 list-item ">
      <div (click)="searchFromHistory(search)" class="pointer">
        {{search?.talentdiscoveryname | titlecase}}
      </div>

    </div>
    <div class="col list-item">
      {{search?.searchedfrom | titlecase}}
    </div>
    <div class="col list-item">
      {{search?.savedon | date: 'MMM d, y'}}
    </div>
    <div class="col list-item">
      {{search?.updatedon | date: 'MMM d, y'}}
    </div>
    <div class="col list-item">
      <div class="d-flex justify-content-between w-100">

        <span class="dropdown ats-dropBtn ml-2">
          <button data-testid="auto-app-search-history-button-1" class="ats-btn btn-break dropdown-toggle ml-3px px-2" type="button" id="userDropdownButton"
            appDropdownToggle aria-haspopup="true" aria-expanded="false">
            <i class="fas fa-ellipsis-v"></i>
          </button>
          <div class="dropdown-menu" aria-labelledby="userDropdownButton">
            <a data-testid="auto-app-search-history-a-3" class="dropdown-item f-12 isActive d-flex" routerLinkActive="active" *ngIf="members?.length && !search?.issharedsearch && save"
              (click)="openSaveSearchShareModal(search)">
              <span class="mr-1"  style="width: 16px;">

              </span>
              <span>Share</span>
            </a>
            <a data-testid="auto-app-search-history-a-4" class="dropdown-item f-12 isActive d-flex" *ngIf="currentUserId == search?.savedby && save" routerLinkActive="active" (click)="editSavedSearch(search)">

              <span>Edit</span>
            </a>
            <a data-testid="auto-app-search-history-a-5" class="dropdown-item f-12 isActive d-flex" routerLinkActive="active" *ngIf="currentUserId == search?.savedby && save" (click)="triggerDeleteSaveModal(search)">
              <span  class="mr-1" style="width: 16px;">
              </span>
              <span class="f-12">Delete</span>
            </a>

            <a data-testid="auto-app-search-history-a-6" class="dropdown-item f-12 isActive d-flex" routerLinkActive="active"
              (click)="searchFromHistory(search)">
              <span>Search</span>
            </a>

            <!-- <a data-testid="auto-app-search-history-a-7" class="dropdown-item f-12 isActive" routerLinkActive="active" (click)="shareProject(project)">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M12.6668 2.66667H10.3335L9.66683 2H6.3335L5.66683 2.66667H3.3335V4H12.6668M4.00016 12.6667C4.00016 13.0203 4.14064 13.3594 4.39069 13.6095C4.64074 13.8595 4.97987 14 5.3335 14H10.6668C11.0205 14 11.3596 13.8595 11.6096 13.6095C11.8597 13.3594 12.0002 13.0203 12.0002 12.6667V4.66667H4.00016V12.6667Z" fill="#484B59"/>
                      </svg>
                    </span>
                    <span>
                      Delete
                    </span>
                  </a> -->
          </div>
        </span>
      </div>
    </div>
  </div>
  }

  <!-- Skeleton loader (initial load and pagination) -->
  @if(searchHistoryLoader){
  @for(item of [1,2,3,4,5]; track item){
  <div class="row mx-0 project-list sk-row" aria-hidden="true">
    <div class="col-md-4 list-item">
      <div class="sk-line" style="width: 70%;"></div>
    </div>
    <div class="col list-item">
      <div class="sk-line" style="width: 60%;"></div>
    </div>
    <div class="col list-item">
      <div class="sk-line" style="width: 55%;"></div>
    </div>
    <div class="col list-item">
      <div class="sk-line" style="width: 55%;"></div>
    </div>
    <div class="col list-item">
      <div class="sk-line sk-icon"></div>
    </div>
  </div>
  }
  }

</div>
</div>



<ng-template #deleteSavedSearchModal class="modal">
    <div class="modal-body px-3 pb-3 pt-3">
      <div class="d-flex justify-content-between mb-3">
        <div>
          <span class="font-weight-600">
            Delete Search
          </span>
        </div>
        <span class="text-bluex pointer">
          <i class="far fa-times f-16" (click)="deleteModalRef?.close()"> </i>
        </span>
      </div>

      <div class="row mt-3 mb-5">
        <div class="col">
          <p class="f-12 mb-0" style="color: #484b59 !important;">Are you sure you want to delete this search?</p>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col d-flex justify-content-end">
          <button data-testid="auto-app-search-history-button-2" class="btn-trms-white mr-3" (click)="deleteModalRef?.close()">Cancel</button>
          <button data-testid="auto-app-search-history-button-3" class="btn-trms-small" (click)="deleteSavedSearch()">OK</button>
        </div>
      </div>
    </div>
</ng-template>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert error-message-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
